module.exports = __webpack_public_path__ + "static/wanderausstellung-geotief-209b9a078a6c46c1dbcceb93edb73caf.pdf";